import 'angular';

import {
  downgradeComponent,
  downgradeInjectable
} from '@angular/upgrade/static';

import '../core/core.module.ajs';

import { ChargifyService }               from './chargify.service';
import { ChargifyTrailMessageComponent } from './chargify.trail-message.component';

angular.module('app-lite.chargify', [
  'app-lite.core'
])
.directive('worChargifyTrialMessage', downgradeComponent({ component: ChargifyTrailMessageComponent }))
.service('chargifyApi', downgradeInjectable(ChargifyService));
